export const branchsSelector = (state) => state.branchReducer.branchs;
export const detailSelector = (state) => state.branchReducer.detail;
export const branchesOwnerSelector = (state) =>
  state.branchReducer.owerBranches;

export const detailBranchSelector = (state) => state.branchReducer.detailBranch;
